import React from "react";
import * as Styles from "./StyledContactUs";
import { ArrowRight } from "../../../images";
import { CircularProgress, IconButton } from "@mui/material";
import { contact } from "../../../images";
import * as Comp from "../../../Components/Form";
import { InputText } from "../Auth/StyledAuth";
import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import { formikProps } from "./validation";
import { useIntl } from "react-intl";
import { POST_REQUEST } from "../../../HooksApi/useApi";
import { USeInsertData } from "../../../HookAxios/postData";
const ContactUs = () => {
  const intl = useIntl();
  const [phone, setPhone] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [Status, setStatus] = React.useState(false);
  const onSubmit = (data) => {
    contactUs({
      ...data,
      phone_number: phone,
      country_code: country,
    });
  };
  const {
    mutate: contactUs,
    status: contactUsStatus,
    data: contactUsData,
    error: contactUserror,
  } = POST_REQUEST({
    request: (data) => USeInsertData("contact_us", data),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {
    setStatus(false);
  }
  function handelOnSettledData(data) {
    setStatus(false);
  }
  const getPhone = (data, country) => {
    setPhone(data);
    setCountry(`00${country}`);
  };
  return (
    <Styles.Section>
      <Styles.RightSection>
        <Styles.HederSection>
          <IconButton onButton>
            <Link to="/">
              <img src={ArrowRight} alt="" />
            </Link>
          </IconButton>
          <Styles.HederText>اتصل بنا</Styles.HederText>
        </Styles.HederSection>
        <Styles.FormSection>
          <Styles.FormCus>
            <Formik
              initialValues={formikProps.initialValues}
              validationSchema={formikProps.validationSchema}
              onSubmit={onSubmit}
              render={({
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
              }) => (
                <Form style={{ width: "100%" }}>
                  <Styles.InputContainer>
                    <InputText>البريد الاكتروني</InputText>
                    <Comp.InputFail
                      width="100%"
                      placeholder="أدخل بريدك الإلكتروني"
                      height="48px"
                      type="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      error={errors.email && touched.email}
                      errorText={
                        errors.email && touched.email ? errors.email : null
                      }
                      name="email"
                    />
                  </Styles.InputContainer>
                  <Styles.InputContainer>
                    <InputText>الاسم الكامل</InputText>
                    <Comp.InputFail
                      width="100%"
                      placeholder=" أدخل اسم والدك"
                      height="48px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.full_name}
                      error={errors.full_name && touched.full_name}
                      errorText={
                        errors.full_name && touched.full_name
                          ? errors.full_name
                          : null
                      }
                      name="full_name"
                    />
                  </Styles.InputContainer>
                  <Styles.InputContainer>
                    <InputText>رقم الهاتف الجوال</InputText>
                    <Comp.PhoneNumInput
                      onBlur={handleBlur}
                      inputProps={{ name: "phone_number" }}
                      onChange={(phoneNumber, country, e) => [
                        handleChange(e),
                        getPhone(
                          Number(
                            phoneNumber.slice(country.dialCode.length)
                          ).toString(),
                          country.dialCode
                        ),
                      ]}
                      error={errors.phone_number && touched.phone_number}
                      errorText={
                        errors.phone_number && touched.phone_number
                          ? errors.phone_number
                          : null
                      }
                      name="phone_number"
                      width="100%"
                      height="40px"
                      placeholder={intl.formatMessage({
                        id: `AuthSignUp.Placeholderphone`,
                      })}
                    />
                  </Styles.InputContainer>
                  <Styles.InputContainer>
                    <InputText>الرسالة *</InputText>
                    <Comp.InputFail
                      width="100%"
                      placeholder="  ماذا تريد أن تخبرنا؟"
                      multiline={true}
                      height="95px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.message}
                      error={errors.message && touched.message}
                      errorText={
                        errors.message && touched.message
                          ? errors.message
                          : null
                      }
                      name="message"
                    />
                  </Styles.InputContainer>
                  <Styles.InputContainer style={{ marginTop: "16px" }}>
                    {!Status ? (
                      <Comp.MuiButton width="100%" height="40px" text="ارسال" />
                    ) : (
                      <CircularProgress sx={{ alignSelf: "center" }} />
                    )}
                  </Styles.InputContainer>
                </Form>
              )}
            />
          </Styles.FormCus>
        </Styles.FormSection>
      </Styles.RightSection>
      <Styles.LeftSection>
        <Styles.ImgEdit src={contact} />
      </Styles.LeftSection>
    </Styles.Section>
  );
};

export default ContactUs;
